module.exports = __webpack_public_path__ + "img/6ne.b845b3fc.svg";